// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://etherscan.io/address/0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f
export const GHO_TOKEN = '0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f';

// https://etherscan.io/address/0x06179f7C1be40863405f374E7f5F8806c728660A
export const GHO_CCIP_TOKEN_POOL = '0x06179f7C1be40863405f374E7f5F8806c728660A';

// https://etherscan.io/address/0xb639D208Bcf0589D54FaC24E655C79EC529762B8
export const GHO_FLASHMINTER_FACILITATOR = '0xb639D208Bcf0589D54FaC24E655C79EC529762B8';

// https://etherscan.io/address/0xA1c93D2687f7014Aaf588c764E3Ce80aF016229b
export const GHO_LIQUIDITY_COMMITTEE = '0xA1c93D2687f7014Aaf588c764E3Ce80aF016229b';

// https://etherscan.io/address/0xD1E856a947CdF56b4f000ee29d34F5808E0A6848
export const GHO_GSM_STEWARD = '0xD1E856a947CdF56b4f000ee29d34F5808E0A6848';

// https://etherscan.io/address/0x167527DB01325408696326e3580cd8e55D99Dc1A
export const GSM_REGISTRY = '0x167527DB01325408696326e3580cd8e55D99Dc1A';

// https://etherscan.io/address/0xFeeb6FE430B7523fEF2a38327241eE7153779535
export const GSM_USDC = '0xFeeb6FE430B7523fEF2a38327241eE7153779535';

// https://etherscan.io/address/0x535b2f7C20B9C83d70e519cf9991578eF9816B7B
export const GSM_USDT = '0x535b2f7C20B9C83d70e519cf9991578eF9816B7B';

// https://etherscan.io/address/0xE5025A7c15a44283A0616567181587eE6A646D64
export const GSM_USDC_FEE_STRATEGY = '0xE5025A7c15a44283A0616567181587eE6A646D64';

// https://etherscan.io/address/0xA4346AEa575fCf5777D32F419E5850E5c68B2329
export const GSM_USDT_FEE_STRATEGY = '0xA4346AEa575fCf5777D32F419E5850E5c68B2329';

// https://etherscan.io/address/0x00e89F4022FD13AD56e321D50612Eec598eF3b72
export const GSM_USDC_PRICE_STRATEGY = '0x00e89F4022FD13AD56e321D50612Eec598eF3b72';

// https://etherscan.io/address/0x20Be7090711995336A13e24B9EA9e05ac2cdd8C0
export const GSM_USDT_PRICE_STRATEGY = '0x20Be7090711995336A13e24B9EA9e05ac2cdd8C0';

// https://etherscan.io/address/0x29F8c924B7aB50649c9597B8811d08f9Ef0310c3
export const GSM_USDC_ORACLE_SWAP_FREEZER = '0x29F8c924B7aB50649c9597B8811d08f9Ef0310c3';

// https://etherscan.io/address/0x6439DA186BD3d37fE7Fd36036543b403e9FAbaE7
export const GSM_USDT_ORACLE_SWAP_FREEZER = '0x6439DA186BD3d37fE7Fd36036543b403e9FAbaE7';

// https://etherscan.io/address/0x98217A06721Ebf727f2C8d9aD7718ec28b7aAe34
export const GHO_AAVE_CORE_STEWARD = '0x98217A06721Ebf727f2C8d9aD7718ec28b7aAe34';

// https://etherscan.io/address/0x46Aa1063e5265b43663E81329333B47c517A5409
export const GHO_BUCKET_STEWARD = '0x46Aa1063e5265b43663E81329333B47c517A5409';

// https://etherscan.io/address/0xC5BcC58BE6172769ca1a78B8A45752E3C5059c39
export const GHO_CCIP_STEWARD = '0xC5BcC58BE6172769ca1a78B8A45752E3C5059c39';

// https://etherscan.io/address/0x8513e6F37dBc52De87b166980Fa3F50639694B60
export const RISK_COUNCIL = '0x8513e6F37dBc52De87b166980Fa3F50639694B60';

export const CHAIN_ID = 1;
